import { useState } from 'react'

import HealthService from 'service/HealthService'
import { IGetDoctorTimeTableList } from 'types/HealthType'

export default function useSaveDoctorAppointment(appointmentInfo: IGetDoctorTimeTableList, closeAfterSave: () => void) {
  const [loading, setLoading] = useState(false)

  const saveDoctorAppointment = () => {
    setLoading(true)
    HealthService.saveDoctorAppointment({
      healthServiceDoctorId: appointmentInfo?.healthServiceDoctorId || 0,
      reservationStartHour: appointmentInfo?.reservationStartHour || '',
      reservationEndHour: appointmentInfo?.reservationEndHour || '',
      id: 0,
      isCame: false,
      isCancel: false,
      cancelDate: null,
    })
      .then((_res) => closeAfterSave())
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }

  return { saveDoctorAppointment, loading }
}
